import React from 'react';
import { Cpu, Wifi, Server, Network } from 'lucide-react';
import WebStepShell from './WebStepShell';
import DeviceMedia from './DeviceMedia';
import type { WebFlowCtx } from './types';

interface Props {
  ctx: WebFlowCtx;
}

const Step4SendWifi: React.FC<Props> = ({ ctx }) => {
  const rows: { icon: React.ReactNode; key: string; value: string }[] = [
    { icon: <Cpu size={18} />, key: 'DEVICE ID', value: ctx.serialNumber },
    { icon: <Wifi size={18} />, key: 'NETWORK NAME', value: ctx.wifiname || '—' },
    { icon: <Server size={18} />, key: 'SERVER', value: ctx.serverUrl || '—' },
    { icon: <Network size={18} />, key: 'BACnet', value: 'Off' },
  ];

  return (
    <WebStepShell
      step="sendWifi"
      onHeaderBack={ctx.openExitModal}
      onCancel={ctx.openExitModal}
      secondary={{ label: 'Back', onClick: ctx.goBack, disabled: ctx.loading }}
      primary={{
        label: ctx.isSecurePage ? 'Open Device Setup Page' : 'Connect',
        onClick: ctx.sendWifiDetails,
        loading: ctx.loading,
        loadingLabel: 'Sending…',
      }}
      media={<DeviceMedia indicator="step1" />}
    >
      <p className="dcfw-eyebrow">SETUP PHASE 4</p>
      <h2 className="dcfw-title">
        Step 4 of 6: Send Wi-Fi details to your SmartEco device
      </h2>

      <div className="dcf-step-intro" style={{ marginTop: 12 }}>
        <p className="dcf-step-intro__heading">Ready to connect</p>
        <p className="dcf-step-subtitle" style={{ margin: 0 }}>
          {ctx.isSecurePage
            ? "We'll open the device setup page in a new tab. Confirm your Wi-Fi details there and submit, then return here and continue to connect to the internet."
            : 'Tap connect device to send your Wi-Fi credentials to the Smart Eco IAQ device and complete setup.'}
        </p>
      </div>

      <div className="dcf-summary-list">
        {rows.map((row) => (
          <div className="dcf-summary-list__row" key={row.key}>
            <span className="dcf-summary-list__left">{row.icon}</span>
            <span className="dcf-summary-list__right">
              <span className="dcf-summary-list__key">{row.key}</span>
              <span className="dcf-summary-list__value">{row.value}</span>
            </span>
          </div>
        ))}
      </div>
    </WebStepShell>
  );
};

export default Step4SendWifi;
